import { defineMessages } from "@formatjs/intl"
import type { MaintenanceScopeOptions } from "./MaintenanceScopeOptions"

export const maintenanceScopeOptionsMessages = defineMessages<MaintenanceScopeOptions>({
	MAJOR_SERVICE: {
		defaultMessage: "Major maintenance",
		id: "conditionAndHistory.latestMaintenance.scope.majorMaintenance",
	},
	MINOR_SERVICE: {
		defaultMessage: "Minor maintenance",
		id: "conditionAndHistory.latestMaintenance.scope.minorMaintenance",
	},
	NO_SELECTION: {
		defaultMessage: "No selection",
		id: "conditionAndHistory.latestMaintenance.scope.noSelection",
	},
})
